/** Only some 403 bodies carry a real i18n key in `message`/`error` (e.g. the shared `FORBIDDEN` constant sends raw text 'Forbidden'), so `isKnownMessageId` gates on the loaded catalog rather than trusting every string. */
export const getForbiddenToastMessageId = (body: unknown, isKnownMessageId: (id: string) => boolean): string => {
  if (body && typeof body === 'object') {
    const { message, error } = body as { message?: unknown; error?: unknown };
    if (typeof message === 'string' && isKnownMessageId(message)) return message;
    if (typeof error === 'string' && isKnownMessageId(error)) return error;
  }
  return 'toast.no-access';
};
